import { reportSalesCumulativeGlobalTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_SALES_CUMULATIVE_GLOBAL_FILTERS,
  RESTORE_INITIAL
} = reportSalesCumulativeGlobalTypes;

const initialState = {
  data: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportSalesCumulativeGlobalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SALES_CUMULATIVE_GLOBAL_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
